import {
  Animation,
  MainHeroSlice,
} from '@adapters/prismic/types/brandedStorePage';
import { MainHeroData, MainHeroCta } from '_components/MainHero/types';

/**
 * Maps a Prismic `main_hero` slice `primary` into `MainHeroData`. Shared by
 * both CategoryPageSliceHandler and LandingPageSliceHandler since the slice
 * has the identical field shape on both custom types.
 */
const mapMainHeroData = (primary: MainHeroSlice['primary']): MainHeroData => {
  const ctas: MainHeroCta[] = [
    primary.cta_1_label && primary.cta_1_link
      ? { label: primary.cta_1_label, url: primary.cta_1_link, slot: 0 }
      : null,
    primary.cta_2_label && primary.cta_2_link
      ? { label: primary.cta_2_label, url: primary.cta_2_link, slot: 1 }
      : null,
  ].filter((cta): cta is MainHeroCta => cta !== null);

  const infoCard =
    primary.info_card_description &&
    primary.info_card_cta_label &&
    primary.info_card_cta_link
      ? {
          description: primary.info_card_description,
          cta: {
            label: primary.info_card_cta_label,
            url: primary.info_card_cta_link,
          },
        }
      : null;

  return {
    h1: primary.title ?? '',
    image: primary.image ?? null,
    mobileImage: primary.image_mobile ?? null,
    ctas,
    infoCard,
    animation: primary.animation ?? Animation.none,
  };
};

export default mapMainHeroData;
